module.exports = __webpack_public_path__ + "img/cpu.e3451899.svg";